module.exports = __webpack_public_path__ + "img/Skirt-Back-B5-Da-Ga-Ha-Ia-Ge.92edb1f3.png";